export default {"src":"/_next/static/media/premium_shiny.a4d67db6.svg","height":20,"width":25};